define('services/common/ajax/openApp',['app', 'mainCons'], function (app, mainCons) {
    app.factory('OpenApp', ['auiAjaxWithError', 'auiAgreementHelper', 'biAnalyticService', '$q', 'auiDialog', '$filter', function (auiAjaxWithError, auiAgreementHelper, biAnalyticService, $q, auiDialog, $filter) {

        var apiToTitle = {
            "GOpenApp.Developer.addApp": "新建产品",
            "GOpenApp.Developer.addAppApk": "添加APK",
            "GOpenApp.Developer.delApp": "删除产品",
            "GOpenApp.Developer.delAppApk": "删除APK",
            "GOpenApp.Developer.updateApp": "修改产品",
            "GOpenApp.Developer.delService": "删除服务",
            "GOpenApp.Developer.shelfOff": "申请服务下架",
            "GOpenApp.Developer.submitAudit": "服务提交审核",
            "GOpenApp.Developer.addService": "新增服务",
            "SOpenApp.Server.modSubAccountStatus":"APIConsole - 修改服务帐号状态",
            'SOpenApp.Server.delProjectAPI':"APIConsole - 停用API",
            'SOpenApp.Server.addProjectAPI':"APIConsole - 启用API",
            "SOpenApp.Server.delClient1":"APIConsole - 删除API秘钥",
            "SOpenApp.Server.delClient2":"APIConsole - 删除 OAuth 2.0 客户端",
            "SOpenApp.Server.delClient3":"APIConsole - 删除服务帐号",
            "SOpenApp.Server.delClient4":"APIConsole - 删除应用级客户端",
            "SOpenApp.Server.delSAKey":"APIConsole - 删除服务帐号密钥",
            "SOpenApp.Server.delOauthAPI":"APIConsole - 删除应用级客户端API",
            "SOpenApp.Server.desProject":"APIConsole - 删除项目"
        }
        var tagTypeOptions ={
            "SOpenApp.Server.delClient1":"DPRM0072",
            "SOpenApp.Server.delClient2":"DPRM0075",
            "SOpenApp.Server.delClient3":"DPRM0080",
            "SOpenApp.Server.delClient4":"DPRM0087"
        }

        function AJAX(options, isCustomError, api, timeout) {
            var defer = $q.defer();
            auiAjaxWithError.curry('openApp', api)(options, isCustomError, timeout).then(function (data) {
                defer.resolve(data);
            }).catch(function (data) {
                defer.reject(data);
            });
            return defer.promise;
        }

        function myCustem(api) {
            //只针对GOpenApp.Developer.addService和GOpenApp.Developer.updateService接口做处理
            return function (options, isCustomError) {
                var defer = $q.defer();
                AJAX(options, true, api).then(function (data) {
                    biAnalyticService.bianalyticLink(apiToTitle[api], options.request.serviceItem, "DPRM0058");
                    defer.resolve(data);
                }).catch(function (data) {
                    if (data['NSP_STATUS'] == 90119647) {//协议变更后处理逻辑
                        auiDialog.warn('请先签署最新版本协议。', function () {
                            var jsO = angular.fromJson(options.request);
                            if(mainCons.appConstant.serviceItemToAgreement[jsO.serviceItem]){
                                auiAgreementHelper.checkAgreements(mainCons.appConstant.serviceItemToAgreement[jsO.serviceItem], function () {
                                    defer.reject(data);
                                },null,true).then(function (result) {
                                    if (result.signed) {
                                        AJAX(options, isCustomError, api).then(function (data) {
                                            defer.resolve(data);
                                        }).catch(function (data) {
                                            defer.reject(data);
                                        });
                                    }
                                });
                            }else{
                                auiAgreementHelper.openSingleResignDialog(jsO.serviceItem, function () {
                                    AJAX(options, isCustomError, api).then(function (data) {
                                        defer.resolve(data);
                                    }).catch(function (data) {
                                        defer.reject(data);
                                    });
                                }, function () {
                                    defer.reject(data);
                                });
                            }
                        });

                    } else {
                        // 如果选择使用公共的能力，则在此获取错误码的资源，并提示
                        auiDialog.failSystemError($filter('auiErrorCode')(data['NSP_STATUS'], data.serviceName), function () {
                            defer.reject(data);
                        });
                    }
                });
                return defer.promise;
            }
        }

        //设置超时时间
        function setAnalyticService(api, outTime,tagType) {
            return function (options, isCustomError) {
                var defer = $q.defer();
                AJAX(options, isCustomError, api, outTime).then(function (data) {
                    if (options && options.request && options.request.serviceItem) {
                        biAnalyticService.bianalyticLink(apiToTitle[api], options.request.serviceItem, "DPRM0025");
                    } else if(options && options.req && options.req.clientType){
                        biAnalyticService.bianalyticLink(apiToTitle[api + options.req.clientType], 1, tagTypeOptions[api + options.req.clientType]);
                    }else {
                        biAnalyticService.bianalyticLink(apiToTitle[api], 1, tagType|| "DPRM0025");
                    }
                    defer.resolve(data);
                }).catch(function (data) {
                    defer.reject(data);
                });
                return defer.promise;
            }
        }


        return {
            getServiceList: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getServiceList'),
            getServiceInfo: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getServiceInfo'),
            addService: myCustem('GOpenApp.Developer.addService'),
            addApp: setAnalyticService('GOpenApp.Developer.addApp'),
            addAppApk: setAnalyticService('GOpenApp.Developer.addAppApk', 300000),
            getAppDetail: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getAppDetail'),
            delApp: setAnalyticService('GOpenApp.Developer.delApp'),
            updateApp: setAnalyticService('GOpenApp.Developer.updateApp'),
            getProductByID: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getProductByID'),
            updateService: auiAjaxWithError.curry('openApp', 'GOpenApp.Developer.updateService'),
            delService: setAnalyticService('GOpenApp.Developer.delService'),
            updateAppAttrs: auiAjaxWithError.curry('openApp', 'GOpenApp.Developer.updateAppAttrs'),
            addProduct: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.addProduct'),
            getTPLMFileList: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getTplmFileList'),
            addAppRpk: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.addAppRpk'),
            getProAbsList: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getProAbsList'),
            getProListByService: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getProListByService'),





            getProductListWithWidget: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getProductListWithWidget'),
            submitServiceWithWidget: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.submitServiceWithWidget'),
            saveServiceWithWidget: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.saveServiceWithWidget'),
            updateServiceWithWidget: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.updateServiceWithWidget'),
            getServiceWithWidget: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.getServiceWithWidget'),
            shelfOffWithWidget: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.shelfOffWithWidget'),
            delServiceWithWidget: auiAjaxWithError.curryWithoutError('openApp', 'GOpenApp.Developer.delServiceWithWidget'),


            getAppBriefList: auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getAppBriefList'),
            queryAppList: auiAjaxWithError.curry('openApp', 'SOpenApp.Server.queryAppList'),
            queryKitList: auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getKitList'),
            //以下给consoleApi使用*
            addProject:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.addProject'),//SOpenApp.Server.addProject
            getProjectList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getProjectList'),//SOpenApp.Server.getProjectList
            delProject:setAnalyticService('SOpenApp.Server.desProject','','DPRM0082'),//SOpenApp.Server.delProject
            getProjectInfo:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getProjectInfo'),//
            getKitList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getKitList'),//
            queryDstbAppList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.queryDstbAppList'),//
            queryDstbAppInfo:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.queryDstbAppInfo'),//
            getAvailableAPIList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getAvailableAPIList'),//SOpenApp.Server.getAvailableAPIList
            getAPIDetail:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getAPIDetail'),//SOpenApp.Server.getAPIDetail
            addProjectAPI:setAnalyticService('SOpenApp.Server.addProjectAPI','','DPRM0069'),//SOpenApp.Server.addProjectAPI
            delProjectAPI:setAnalyticService('SOpenApp.Server.delProjectAPI','','DPRM0068'),//SOpenApp.Server.delProjectAPI
            getProjectAPI:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getProjectAPI'),//SOpenApp.Server.getProjectAPI
            getProjectCredentialList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getProjectCredentialList'),//SOpenApp.Server.getProjectCredentialList
            addApiKey:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.addAPIKey'),//SOpenApp.Server.addApiKey
            modApiKey:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.modAPIKey'),//SOpenApp.Server.modApiKey
            delClient:setAnalyticService('SOpenApp.Server.delClient','','DPRM0072'),//SOpenApp.Server.delClient
            addSubAccount:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.addSubAccount'),//SOpenApp.Server.addSubAccount
            addOauthClient: auiAjaxWithError.curry('openApp','SOpenApp.Server.addOauthClient'),
            modOauthClient:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.modOauthClient'),
            addSAKey:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.addSAKey'),//SOpenApp.Server.addSAKey
 	        delSAKey:setAnalyticService('SOpenApp.Server.delSAKey','','DPRM0079'),//SOpenApp.Server.delSAKey
            modSubAccountStatus:setAnalyticService('SOpenApp.Server.modSubAccountStatus','','DPRM0081'),//SOpenApp.Server. modSubAccountStatus
            getOauthAPI:auiAjaxWithError.curryWithoutError('openApp', 'SOpenApp.Server.getOauthAPI'),//SOpenApp.Server. modSubAccountStatus
            addOauthAPI:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.addOauthAPI'),//SOpenApp.Server. modSubAccountStatus
            delOauthAPI:setAnalyticService('SOpenApp.Server.delOauthAPI','','DPRM0086'),//SOpenApp.Server. modSubAccountStatus
            modOauthAPI:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.modOauthAPI'),//SOpenApp.Server. modSubAccountStatus
            getAPIList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getAPIList'),//SOpenApp.Server.getAPIList
            getProjectListByID:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getProjectListByID'),//SOpenApp.Server.getProjectListByID

            //以下给Scope授权申请和审核机制使用
            getProjApiScopeList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getProjApiScopeList'),
            getUserProjScopeList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.getUserProjScopeList'),
            addProjScopeList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.addProjScopeList'),
            applyProjScopeList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.applyProjScopeList'),
            delProjScopeList:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.delProjScopeList'),
            addOauthClientV2:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.addOauthClientV2'),
            modOauthClientV2:auiAjaxWithError.curry('openApp', 'SOpenApp.Server.modOauthClientV2')

        }
    }]);
});
